<template>
  <div>
    <div class="px-4 sm:px-6 md:px-8 mb-8">
      <div>
        <div class="mb-8">
          <div>
            <h1 class="text-2xl font-semibold text-gray-900">Dashboard</h1>
          </div>
        </div>
        <div
          class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 mt-4"
        >
          <div class="bg-white overflow-hidden shadow rounded-lg">
            <div class="px-4 py-5 sm:p-6">
              <div class="flex items-center">
                <div class="flex-shrink-0 bg-indigo-500 rounded-md p-3">
                  <svg
                    class="h-6 w-6 text-white"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                    ></path>
                    <path d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  </svg>
                </div>
                <div class="ml-5 w-0 flex-1">
                  <dl>
                    <dt
                      class="text-sm leading-5 font-medium text-gray-500 truncate"
                    >
                      Clips
                    </dt>
                    <dd class="flex items-baseline">
                      <div
                        class="text-2xl leading-8 font-semibold text-gray-900"
                      >
                        {{ clips.total }}
                      </div>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <div class="bg-gray-50 px-4 py-4 sm:px-6">
              <div class="text-sm leading-5">
                <router-link
                  :to="{ name: 'clips' }"
                  href="#"
                  class="font-medium text-indigo-600 hover:text-indigo-500 transition ease-in-out duration-150"
                >
                  Voir tous les clips
                </router-link>
              </div>
            </div>
          </div>
          <div class="bg-white overflow-hidden shadow rounded-lg">
            <div class="px-4 py-5 sm:p-6">
              <div class="flex items-center">
                <div class="flex-shrink-0 bg-indigo-500 rounded-md p-3">
                  <svg
                    class="h-6 w-6 text-white"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                    ></path>
                  </svg>
                </div>
                <div class="ml-5 w-0 flex-1">
                  <dl>
                    <dt
                      class="text-sm leading-5 font-medium text-gray-500 truncate"
                    >
                      Projets
                    </dt>
                    <dd class="flex items-baseline">
                      <div
                        class="text-2xl leading-8 font-semibold text-gray-900"
                      >
                        {{ projects.length }}
                      </div>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <div class="bg-gray-50 px-4 py-4 sm:px-6">
              <div class="text-sm leading-5">
                <router-link
                  :to="{ name: 'projects' }"
                  href="#"
                  class="font-medium text-indigo-600 hover:text-indigo-500 transition ease-in-out duration-150"
                >
                  Voir tous les projets
                </router-link>
              </div>
            </div>
          </div>
          <div class="bg-white overflow-hidden shadow rounded-lg">
            <div class="px-4 py-5 sm:p-6">
              <div class="flex items-center">
                <div class="flex-shrink-0 bg-indigo-500 rounded-md p-3">
                  <svg
                    class="h-6 w-6 text-white"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                </div>
                <div class="ml-5 w-0 flex-1">
                  <dl>
                    <dt
                      class="text-sm leading-5 font-medium text-gray-500 truncate"
                    >
                      Nombre de membres
                    </dt>
                    <dd class="flex items-baseline">
                      <div
                        class="text-2xl leading-8 font-semibold text-gray-900"
                      >
                        {{ users.length }}
                      </div>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <div class="bg-gray-50 px-4 py-4 sm:px-6">
              <div class="text-sm leading-5">
                <router-link
                  :to="{ name: 'team' }"
                  href="#"
                  class="font-medium text-indigo-600 hover:text-indigo-500 transition ease-in-out duration-150"
                >
                  Voir l'équipe
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
    data() {
        return {};
    },
    computed: {
        ...mapGetters("clip", ["clips"]),
        ...mapState("project", ["projects"]),
        ...mapState("team", ["users"])
    }
};
</script>